import { mlpEnvironment } from './mlp-environment';

export const mlpPortalDashboardUrl = new URL('dashboard', mlpEnvironment.portalUrl).href;
